import React from "react";
import PropTypes from "prop-types";
import {Redirect} from "react-router-dom";
import noty from "../../lib/noty";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import FieldCheck from "../FieldCheck";
import {Subscribe, appContainer} from "../../contexts/app";

class TrainingModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      redirect: null,
      currentUser: this.props.currentUser,
      activeTutorial: this.props.trainingTutorials.toList().toJS()[0],
      touched: false
    };
  }

  handleChange = ({id}) => {
    const {currentUser} = this.state;
    const index = currentUser.trainingTutorials.findIndex(tut => tut === id);
    // If the ID does not exist in the users trainingTutorials, add it.
    if (index === -1) {
      this.setState({
        touched: true,
        currentUser: currentUser.setIn(["trainingTutorials", currentUser.trainingTutorials.length], id)
      });
    } else {
      const updatedTutorialIds = currentUser.trainingTutorials.filter(_id => _id !== id);
      this.setState({
        touched: true,
        currentUser: currentUser.setIn(["trainingTutorials"], updatedTutorialIds)
      });
    }
  };

  handleVideoChange = tutorial => {
    this.setState({activeTutorial: tutorial});
  };

  handleClose = event => {
    if (this.state.touched) {
      event.preventDefault();
      const {currentUser} = this.state;
      this.setState({fetching: true});
      currentUser
        .patch()
        .then(patchedUser => {
          this.setState({
            fetching: false,
            touched: false
          });
          noty.success("Tutorials updated.");
        })
        .catch(err => {
          this.setState({fetching: false});
          noty.errors(err);
        });
    }
    this.props.onClose();
  };

  renderTutorialList(trainingTutorials) {
    const {fetching, currentUser, activeTutorial} = this.state;
    return trainingTutorials
      .toList()
      .toJS()
      .map(tutorial => {
        return (
          <div style={{paddingBottom: 16}} key={tutorial._id}>
            <Grid container style={{paddingBottom: 16}}>
              <Grid item md={8}>
                <FieldCheck
                  label={tutorial.description}
                  name={tutorial._id}
                  onChange={({name}) => {
                    this.handleChange({
                      id: name
                    });
                  }}
                  checked={currentUser.trainingTutorials.includes(tutorial._id)}
                  disabled={fetching}
                />
              </Grid>
              <Grid item md={4}>
                <Button
                  onClick={() => this.handleVideoChange(tutorial)}
                  color="primary"
                  disabled={activeTutorial.link === tutorial.link}>
                  Watch Video
                </Button>
              </Grid>
            </Grid>
            <Divider />
          </div>
        );
      });
  }

  render() {
    const {fetching, activeTutorial} = this.state;
    const {trainingTutorials} = this.props;
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const actions = [
      <Button color="primary" onClick={this.handleClose} disabled={fetching}>
        Done
      </Button>
    ];

    return (
      <Dialog maxWidth="md" actions={actions} open={true} onClose={this.handleClose} style={{maxWidth: 1200}}>
        <DialogTitle>
          Welcome to <span className="colorBlue">MapPlug</span>! Let's learn how to use it...
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{paddingTop: 16, paddingBottom: 16}}>
            To be proficient with the system, you should master a few basic tasks. Watch a video about each task, try it
            at your own facility, and then check it off here.
          </DialogContentText>
          <Grid container spacing={24}>
            <Grid item md={5}>
              {this.renderTutorialList(trainingTutorials)}
            </Grid>
            <Grid item md={7}>
              <div>
                <span>{activeTutorial.description}</span>
                {/*
                    TODO: when a user pauses a video, keep the video paused time in state so they can resume where they left off (while working through a tutorial, for example). This would require a more robust video component
                  */}
                <iframe
                  title="videoPlayer"
                  src={activeTutorial.link}
                  width="500"
                  height="300"
                  frameBorder="0"
                  allowFullScreen
                />
                {activeTutorial.zendeskLink && (
                  <p style={{textAlign: "center"}}>
                    <a href={activeTutorial.zendeskLink} target="_blank">
                      Watch this video in a new tab with step-by-step instructions
                    </a>
                  </p>
                )}
              </div>
            </Grid>
          </Grid>
          <DialogContentText style={{marginTop: 32}}>
            Choose "Training" from the drop down menu to return to this screen any time
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Done
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

TrainingModal.propTypes = {
  onClose: PropTypes.func,
  currentUser: PropTypes.object
};

export default routerProps => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        return (
          <TrainingModal
            {...routerProps}
            currentUser={app.state.get("currentUser")}
            trainingTutorials={app.state.get("trainingTutorials")}
          />
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/TrainingModal/index.jsx